import { render, staticRenderFns } from "./MaterialAssortments.vue?vue&type=template&id=53d3f3fb"
import script from "./MaterialAssortments.vue?vue&type=script&lang=js"
export * from "./MaterialAssortments.vue?vue&type=script&lang=js"
import style0 from "./MaterialAssortments.vue?vue&type=style&index=0&id=53d3f3fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports